import { Form, Field, FormElement, FieldWrapper, FieldRenderProps, FormRenderProps } from '@progress/kendo-react-form';
import { Label, Error, Hint, FloatingLabel } from '@progress/kendo-react-labels';
import { Checkbox, CheckboxChangeEvent, Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCopy, faInfoCircle,faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { SubmitNewAdOrder,SubmitNewSpecOrder } from './InfoBoxes';
import { useContext, useEffect, useState } from 'react';
import { SubmissionContext } from './SubmissionFormContext';
import { PageContext } from './PageContext';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { SiteList, CustomerList, RepList } from './FormComponents';
import { FieldLabels, salesRep, SiteEntry } from '../services/interfaces';
import { fieldLables } from './Configuration';
import { DateTime } from 'luxon';
import { UserContext } from './UserContext';
import { FixIllegalChars } from '../services/helpers';

function BasicForm(){
    const subContext=useContext(SubmissionContext);
    const pageContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    const [fldLabels, setFldLabels]=useState<FieldLabels>();
    //const [adNumDisabled, setAdNumDisabled]=useState(true);
    const [acctDisabled, setAcctDisabled]=useState(false);
    
    const checkState=()=>{
        const isValid = validateBasic();
        console.log(subContext?.submitForm);
    }

    const fetchLabels = () => {
        fieldLables().then(labels=>{
            //console.log(labels);
            setFldLabels(labels);
        });
    };

    const setSubmitSite = (site: SiteEntry[]) => {
        //console.log("Selected sites:"+ site);
        const siteCode = site[0];        
        subContext?.setSubmitForm(prevObject=>({...prevObject,site:site[0]}));
        //checkState();
    }

    const enableAccount=()=>{
        setAcctDisabled(false);
    }

    const disableAccount=()=>{
        setAcctDisabled(true);
    }

    const setSubmitCustomer=(customer:{customer:string, fileSize2:string, file1:string}|undefined)=>{
        if (customer){
            console.log("Set Customer: " + customer);
            var acct = "";
            if (customer.fileSize2==""){
                //no account number so make a new one
                var site = subContext?.submitForm.site.code||""
                acct =  site + customer.customer.slice(0,10).replaceAll(" ","_");
                acct=FixIllegalChars(acct,true);
                enableAccount();
            }else{
                acct = customer.fileSize2;
                disableAccount();
            }
            const newCust={customer:FixIllegalChars(customer.customer,true),fileSize2:acct, file1:customer.file1}
            subContext?.setSubmitForm(prevObject=>({...prevObject,customer:newCust}));        
            //const custObj:{customer:string, fileSize2:string,file1:string}=JSON.parse(JSON.stringify(customer));
            subContext?.setSubmitForm(prevObject=>({...prevObject,account:acct}))
            //checkState();
        }
    }

    const setSubmitAccount=(event:InputChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,account:event.value}))
        //checkState();
    }

    const setSubmitRep=(rep:salesRep[])=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,salesRep:rep[0]}));
        //checkState();
    }

    const setSubmitAutoAdNum=(event:CheckboxChangeEvent)=>{
            console.log(event.value);
            getAutoAdNum(event.value);
            subContext?.setAdNumDisabled(event.value);
    }

    const setCustomAdNum=(event: InputChangeEvent)=>{
        const sitePrefix = subContext?.submitForm.site.code;
        var adNum = FixIllegalChars(event.value,false);

        const siteLen = sitePrefix?.length||2;

        if (adNum.substring(0,siteLen)==sitePrefix){
            subContext?.setSubmitForm(prevObject=>({...prevObject,element:adNum, slug:adNum}));
        }else{
            subContext?.setSubmitForm(prevObject=>({...prevObject,element:(sitePrefix+"-"+adNum), slug:(sitePrefix+"-"+adNum)}));
        }
    }

    const getAutoAdNum=(auto:Boolean)=>{
        console.log("SetAutoAdNum: " + auto );
        console.log("Sub Type: " + subContext?.submitForm.subType );
        if (auto){
            //auto generate ad number
            const now=DateTime.now();
            var newAdNum="";
            switch (subContext?.submitForm.subType){
                case "NO":
                    newAdNum = "AT" + now.toFormat("MMddHHmmss");
                    break;
                case "SP":
                    newAdNum = "SPAD" + now.toFormat("MMddHHmmss");
                    break;
                case "OS":
                    newAdNum = "AT" + now.toFormat("MMddHHmmss");
                    break;
                case "MK":
                    newAdNum = "AT" + now.toFormat("MMddHHmmss");
                    break;
                case "SB":
                case "CR":
                    break;
            }
            console.log(newAdNum);
            const sitePrefix = subContext?.submitForm.site.code;
              
            const extension = subContext?.submitForm.extension;
            var newElement="";
            var newSlug = ""
            if (sitePrefix!=""){
                newElement = sitePrefix +"-"+newAdNum+extension;
                newSlug = sitePrefix +"-"+newAdNum;                
            }else{
                newElement = newAdNum+extension;
                newSlug = newAdNum;                                
            }
            subContext?.setSubmitForm(prevObject=>({...prevObject,element:newElement}));
            subContext?.setSubmitForm(prevObject=>({...prevObject,slug:newSlug}));
            subContext?.setAdNumDisabled(true);
            checkState();
        }else{
            if (subContext?.submitForm.element==""){
                subContext?.setSubmitForm(prevObject=>({...prevObject,element:""}));
                subContext?.setSubmitForm(prevObject=>({...prevObject,slug:""}));
                subContext?.setAdNumDisabled(false);
                checkState();
            }
        }
    }

    const setSubmitTag=(event:InputChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,tagline:event.value}));
        //checkState();
    }

    const setSubmitComment=(event:InputChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,comment:event.value}));
        //checkState();
    }


    const setSubmitColor=(event:DropDownListChangeEvent)=>{
        subContext?.setSubmitForm(prevObject=>({...prevObject,color:event.value}));
        //checkState();
    }

    const setAdType=(event:DropDownListChangeEvent)=>{
        console.log("Set Ad Type: " + event.value.value);
        var extension = pageContext?.glSettings.StaticAdExtension.toString()||"";
        if (event.value.value=="RM" && pageContext?.glSettings.UseStaticDynamicExtension){
            extension = pageContext?.glSettings.DynamicAdExtension.toString()||"";
        }
        subContext?.setSubmitForm(prevObject=>({...prevObject,adType:event.value}));
        subContext?.setSubmitForm(prevObject=>({...prevObject,extension:extension}));
        checkState();
    }

    const setFormValid=(val:boolean)=>{
        const subValid = subContext?.submitValid;
        if (subValid) {
            subValid.basic = val;
            if (subContext) {
                subContext.submitValid = subValid;
            }
        }
        //subContext?.setSubmitValid((prevObject: { basic: boolean }) => ({ ...prevObject, basic: val }));
    }

     function copyClipboard(field:string){
        var fieldVal = "";
        switch(field){
            case "element":
                fieldVal=subContext?.submitForm.element || "";
        }
        navigator.clipboard.writeText(fieldVal);
    }

    const validateBasic=()=>{
        if (validAdType() && validSite() && validAdNum() && validCustomer() && validAccount() && validRep() && validColor()){
            console.log("Validate Basic: true");
            setFormValid(true);
        }else{
            console.log("Validate Basic: false");
            setFormValid(false);
        }
    }

    const validAdType=()=>{
        if (subContext?.submitForm.adType.value!==""){
            return(true);
            console.log("Ad type valid");
        }else{
            return(false);
            console.log("Ad type invalid");
        }
    }
    const validSite=()=>{
        if (subContext?.submitForm.site.code!==""){
            return(true);
            console.log("Site valid");
        }else{
            return(false);
            console.log("Site invalid");
        }
    }
    const validAdNum=()=>{
        if (subContext?.submitForm.element!==""){
            return(true);
            console.log("AdNum valid");
        }else{
            return(false);
            console.log("AdNum invalid");
        }
    }
    const validCustomer=()=>{
        if (subContext?.submitForm.customer.customer!=""){
            return(true);
            console.log("Customer valid");
        }else{
            return(false);
            console.log("Customer invalid");
        }
    }
    const validAccount=()=>{
        if (subContext?.submitForm.account!==""){
            return(true);
            console.log("Account valid");
        }else{
            return(false);
            console.log("Account invalid");
        }
    }
    const validRep=()=>{
        if (subContext?.submitForm.salesRep.customer!==""){
            return(true);
            console.log("Rep valid");
        }else{
            return(false);
            console.log("Rep invalid");
        }
    }
    const validColor=()=>{
        if (subContext?.submitForm.color.value!==""){
            return(true);
            console.log("Color valid");
        }else{
            return(false);
            console.log("Color invalid");
        }
    }

    useEffect(()=>{
        fetchLabels();
    },[])

    useEffect(()=>{
        checkState();
    },[subContext?.submitForm])

    useEffect(()=>{
        if (subContext) {
            getAutoAdNum(subContext.adNumDisabled);
        }
    },[subContext?.submitForm.subType,subContext?.submitForm.site]);
    return(
    <div>
        <h5>BASIC AD INFORMATION</h5>
        <SubmitNewAdOrder /> 
        <FieldWrapper>
            <Label>Ad Type:*</Label>
            <DropDownList
                fillMode={"outline"}
                data={[{text:"PRINT", value:"DA"},{text:"ONLINE",value:"RM"}]}
                textField='text'
                dataItemKey='value'
                value ={subContext?.submitForm.adType}
                onChange={setAdType}
                valid={validAdType()}
            />
        </FieldWrapper>
        <FieldWrapper>
            <Label>Site:*</Label>
            <SiteList setReturnAction={setSubmitSite} value={subContext?.submitForm.site || []} multi={false} valid={validSite()} className='formField'/>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Ad #:* <a href="#" onClick={() => copyClipboard("element")}><FontAwesomeIcon icon={faCopy}></FontAwesomeIcon></a>
            </Label>
            <Checkbox checked={subContext?.adNumDisabled} onChange={setSubmitAutoAdNum}>&nbsp;Automaticaly generate a new ad number</Checkbox>
            <Input disabled={subContext?.adNumDisabled} value={subContext?.submitForm.element} valid={validAdNum()} onChange={setCustomAdNum}></Input>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Customer:</Label>
            <CustomerList setReturnAction={setSubmitCustomer} value={subContext?.submitForm.customer || { customer: '', fileSize2: '', file1: '' }} site={subContext?.submitForm.site || ""} valid={validCustomer()} allowNew={true}/>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Account:</Label>
            <Input value={subContext?.submitForm.account} valid={validAccount()} disabled={acctDisabled} onChange={setSubmitAccount} maxLength={13}></Input>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Sales Rep:</Label>
            <RepList setReturnAction={setSubmitRep} value={subContext?.submitForm.salesRep ? [subContext.submitForm.salesRep] : []} multi={false} site={subContext?.submitForm.site||""} valid={validRep()}/>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Color:</Label>
            <DropDownList
                fillMode={"outline"}
                data={[
                    { text: "Black & White", value: "0" },
                    { text: fldLabels?.Color || "Color", value: "1" }
                ]}
                textField='text'
                dataItemKey='value'
                value ={subContext?.submitForm.color}
                onChange={setSubmitColor}
                valid={validColor()}
            />
        </FieldWrapper>
        <FieldWrapper>
            <Label>Tagline:</Label>
            <Input maxLength={79} onChange={setSubmitTag} value={subContext?.submitForm.tagline}></Input>
        </FieldWrapper>
        <FieldWrapper>
            <Label>Comment:</Label>
            <Input maxLength={119} onChange={setSubmitComment} value={subContext?.submitForm.comment}></Input>
        </FieldWrapper>
    </div>
    )
}

export const SubmitBasic =(
    <BasicForm/>
)